import { http, ep } from '../../client/http';

export const companyInfoRepo = {
  get: async () => {
    const res = await http.get(ep('companyInfo/list'), {
      params: { status: true }
    });
    return res.data.data;
  }
};
